import styled from 'styled-components'

import { LINK_COLOR, TEXT_GREY, FONT_BASE_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_LG, BREAK_POINT_MD, BREAK_POINT_SM } from '@CSSVars/variables'


export const _RootContainer = styled.main`
  background: white;
  margin-top: 24px;
  min-height: calc(100vh - 60px);
  padding-bottom: ${({ isMobileApp }) => (
    isMobileApp ? '80px !important' : '0'
  )};

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    margin-top: 0;
  }
`

export const _TopBanner = styled.div`
  display: flex;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    ${({ isMobileApp }) => (isMobileApp &&
    `
    width: 100%;
    height: 90px;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    `)};
  }
`

export const _MaxWidthContainer = styled.div`
  width: calc(100% - 140px);
  max-width: 1140px;
  margin: auto;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: calc(100% - 48px) !important;
  }
`

export const _Title = styled.div`
  display: inline-flex;
  white-space: nowrap;
  flex-wrap: wrap;
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: 500;
  a, span {
    line-height: 34px;
    font-size: 28px;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 16px;
    font-weight: 600;
    line-height: 36px;
    margin-bottom: 0;
    a, div, span {
      white-space: normal;
      font-size: 16px;
      font-weight: 600;
      line-height: 36px;
    }

  }
`

export const _TitleLink = styled.div`
  line-height: 34px;
  font-size: 28px;
  color: ${(props) => (props.hasUrl ? LINK_COLOR : '')};
  text-decoration: ${(props) => (props.hasUrl ? 'underline' : '')};
  white-space: nowrap;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    text-decoration: none;
    color: ${FONT_BASE_COLOR};
    pointer-events: none;
  }
`

export const _Address = styled.div`
  line-height: 24px;
  font-size: 12px;
  width: 100%;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    line-height: 15px;
    font-size: 10px;
    color: ${TEXT_GREY};
  }
`

export const _ArchiveListings = styled.div`
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  padding-bottom: 80px;
  ${({ isMobileApp }) => (isMobileApp && 'margin: 100px auto;')};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: initial !important;
    max-width: initial !important;
    label[for="Past_Listings"] {
      width: calc(100% - 40px);
      margin-left: auto;
      margin-right: auto;
      max-width: 708px;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) and (min-width: ${BREAK_POINT_MD}) {
    width: 100% !important;
  }
`

export const _BackBtnContainer = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  svg{
    fill: ${LINK_COLOR};
  }
`

export const _TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isMobileApp }) => (isMobileApp ? 'calc(100% - 80px)' : 'calc(100% - 140px)')};
  max-width: 1140px;
  margin:${({ isMobileApp }) => (isMobileApp ? '0 24px 0 56px' : '40px auto 32px auto')};
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: ${({ isMobileApp }) => (isMobileApp ? 'calc(100% - 80px)' : 'calc(100% - 88px)')};
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin:${({ isMobileApp }) => (isMobileApp ? '0 24px 0 56px' : '16px auto')};
    width: ${({ isMobileApp }) => (isMobileApp ? 'calc(100% - 80px)' : 'calc(100% - 48px)')};
  }
`

